import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

export const printConsolidationCartonShippingLabel = {
  name: "printConsolidationCartonShippingLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
  }),
  output: z.object({ url: z.string() }),
};
